import { render, staticRenderFns } from "./DOTSPatientEdit.vue?vue&type=template&id=e6e4ed0e&scoped=true"
import script from "./DOTSPatientEdit.vue?vue&type=script&lang=js"
export * from "./DOTSPatientEdit.vue?vue&type=script&lang=js"
import style0 from "./DOTSPatientEdit.vue?vue&type=style&index=0&id=e6e4ed0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e4ed0e",
  null
  
)

export default component.exports